import React from 'react';
import Firebase from 'firebase';
import Select from 'react-select';

export default class addOutPut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            forms: {},
            elements: {},
            value: [],
            showModal: false,
            name: ""
        }
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSendOutPut = this.handleSendOutPut.bind(this);
    }
    componentWillMount() {
        this.setOptions(this.props.elements)
    }

    setOptions(forms) {
        var options = [];
        Object.values(forms).map((f) => {
            Object.values(f.elements).map((m, index) => {
                var value = {
                    label: m.element_id + " : " + m.id,
                    value: m.id
                }
                options.push(value);
            })
        });
        var global = [
            {
                label: "GLOBAL: gps",
                value: "gps"
            },
            {
                label: "GLOBAL: usuario",
                value: "user"
            },
            {
                label: "GLOBAL: Identificador",
                value: "key"
            },
            {
                label: "GLOBAL: fecha",
                value: "date"
            },
        ]
        global.map(g => {
            options.push(g)
        })
        this.setState({ options: options });
    }

    handleSelectChange(value) {
        this.setState({ value });
        var array = value.split(',');
        this.setState({ selected: array });
    }

    handleSendOutPut() {
        var name = this.state.name;
        var obj = {
            [name]: this.state.selected
        }
        this.props.callBack(obj);
    }

    render() {
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre:</label>
                        <input type="text" className="form-control" id="name" value={this.state.name}
                            placeholder="Nombre del formato"
                            onChange={(e) => { this.setState({ name: e.target.value }) }} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Elementos:</label>
                        <div className="section">
                            <Select multi simpleValue value={this.state.value} placeholder="Seleccione elementos" options={(this.state.options)} onChange={this.handleSelectChange} />
                        </div>
                    </div>
                    <div>
                        <div className="text-right">
                            <a pullRight  onClick={() => this.handleSendOutPut()} className="btn btn-success">Añadir</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forms/addOutPut.js